import { Avatar, Stack, Typography } from "@mui/material";
import BoxHeader from "../atoms/BoxHeader";
import TabsComponent from "../atoms/Tabs";
import React, { useState, useEffect, useMemo } from "react";
import DashboardGeneral from "../molecules/DashboardGeneral";
import ReportKPI from "../../views/Reportes/components/ReportKPI";

import Navbar from "./Navbar";
import useWexClient from "../../hooks/Clients/wexClient,";
import { useContext } from "react";
import { AuthContext } from "../../Auth/Context";
import stylesDashboard from "../../styles/Organisms/OpcionDashboard/dasboard";
import SelectDashboard from "../atoms/SelectDashboard";
import stylesReports from "../../styles/Organisms/OpcionesReportes/reports";
import { usePermissions } from "../../hooks/usePermissions";
import HeatMapDashboard from "../../views/OptionDashboard/MapsType/HeatMapDashboard";

function OpcionDashboard() {
  const { payload } = useContext(AuthContext);
  const { can } = usePermissions(payload);
  const isAdmin = useMemo(() => {
    const profileClass = payload?.profile?.class?.trim();

    return ["_ADMIN_", "_SUPERVISOR_"].includes(profileClass);
  }, [payload]);

  //Permisos
  const canReadKPI = can("dashboard", "kpis");
  const canSeeHeatMap = can("dashboard", "heatmap");

  const [windowChanged, setWindowChanged] = useState(false);
  const [value, setValue] = useState("1");
  const [tabs, setTabs] = useState([]);
  useEffect(() => {
    const baseTabs = [
      {
        label: "Dashboard General",
        key: "1",
      },
    ];

    if (canReadKPI) {
      baseTabs.push({
        label: "KPI",
        key: "2",
      });
    }

    if (canSeeHeatMap) {
      baseTabs.push({
        label: "Heatmap",
        key: "3",
      });
    }

    setTabs(baseTabs);
  }, [canReadKPI, isAdmin]);

  const { getServices, getStatusAgent } = useWexClient();
  const [service, setService] = useState([]);
  const [image, setImage] = useState([]);
  const [selectedOption, setSelectedOption] = useState("");
  const [selectedData, setSelectedData] = useState("");
  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth > 775);

  const handleResize = () => {
    setIsLargeScreen(window.innerWidth > 775);
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleSelectChange = (selectedOptionId) => {
    setSelectedOption(selectedOptionId);
    sessionStorage.setItem("SelectedOption", selectedOptionId);
  };

  useEffect(() => {
    const fetchDataFromAPI = async () => {
      try {
        const apiData = await getServices(payload._id);

        const serviceData = apiData.map((item) => ({
          id: item._id,
          name: item.name,
          permissions: item.permissions,
        }));

        const imageData = apiData.map((item) => item._config.avatarClient);

        setService(serviceData);
        setImage(imageData);

        const initialOption = serviceData.length > 0 ? serviceData[0].id : "";
        setSelectedOption(initialOption);
        sessionStorage.setItem("SelectedOption", initialOption);
      } catch (error) {
        console.error(error);
      }
    };

    if (payload?._id) {
      fetchDataFromAPI();
    }
  }, [payload._id]);

  const selectedPosition = service.findIndex(
    (option) => option.id === selectedOption,
  );

  const selectedImage = selectedPosition !== -1 ? image[selectedPosition] : "";

  // Obtener el nombre del servicio seleccionado
  const selectedService = service.find(
    (option) => option.id === selectedOption,
  );
  const serviceName = selectedService ? selectedService.name : "Cargando...";
  const selectedPermissions = selectedService?.permissions || {};

  return (
    <Stack
      sx={{
        width: "100vw",
        minHeight: "100vh",
        height: "auto",
      }}
    >
      <Stack sx={{ width: "100%" }}>
        <Navbar />
      </Stack>

      <Stack
        className=""
        sx={{
          ...stylesReports.color,
          width: "100vw",
        }}
      >
        <BoxHeader>
          <Stack
            direction="column"
            sx={{
              alignItems: "center",
              width: "100%",
            }}
          >
            <Stack
              direction="row"
              style={{
                ...stylesDashboard.div,
                marginTop: "1rem",
              }}
            >
              <Stack>
                <div
                  style={{
                    ...stylesDashboard.divb,
                    width: "8rem",
                    height: "8rem",
                    borderRadius: "35rem",
                  }}
                >
                  {selectedImage !== null ? (
                    <Avatar
                      src={selectedImage}
                      sx={{
                        width: "100%",
                        height: "100%",
                      }}
                    />
                  ) : (
                    console.log("No se ha encontrado una imagen")
                  )}
                </div>
              </Stack>

              <Stack
                sx={{
                  ...stylesDashboard.title,
                  marginLeft: "1rem",
                  marginTop: "10rem",
                }}
              >
                <Typography variant="h4">{serviceName}</Typography>
              </Stack>
            </Stack>
            <Stack
              sx={{ width: "60%", marginTop: "3rem", marginBottom: "1rem" }}
            >
              <TabsComponent
                value={value}
                setValue={setValue}
                tabs={tabs}
                selectedBackgroundColor="#0c4a91ff"
              />
            </Stack>
          </Stack>
        </BoxHeader>
      </Stack>

      <Stack
        sx={{
          width: "100vw",
          alignItems: "center",
          backgroundColor: "white",
          flexGrow: 1,
          paddingBottom: value === "3" ? 0 : "3rem",
        }}
      >
        <Stack
          sx={{
            width: ["2", "3"].includes(value) ? "100%" : "60%",
            px: ["2", "3"].includes(value) ? 3 : 0,
            marginTop: 0,
          }}
        >
          {value === "1" && (
            <DashboardGeneral
              selectedOption={selectedOption}
              setSelectedOption={setSelectedOption}
              permissions={selectedPermissions}
            />
          )}
          {value === "2" && <ReportKPI selectedOption={selectedOption} />}
          {value === "3" && (
            <HeatMapDashboard selectedOption={selectedOption} />
          )}
        </Stack>
      </Stack>
    </Stack>
  );
}

export default OpcionDashboard;
